define('lq/events/actions/plugInLogin',[
    'jquery',
    'lq',
    'lq/events/actions/eventAction',
    'lq/queryString'
], function ($, lq, EventAction, queryString) {
    'use strict';

    function PlugInLogin(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(PlugInLogin, EventAction);

    PlugInLogin.typeName = 'PlugInLogin';

    PlugInLogin.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    PlugInLogin.prototype.execute = function (continuation) {
        this.piping.dispatcher.dispatch(
            'LicquidAction/LoginCommand', {
                actionId: this.piping.actionId,
                commandId: this.eventData.command,
                captcha: this.getCaptcha(),
                appId: queryString.getValueOf('AppId'),
                parameters: this.getParameters()
            }, this.handleResult.bind(this, continuation));
    };

    PlugInLogin.prototype.getParameters = function() {
        var parameters = {};

        var self = this;
        _.each(this.eventData.parameterMappings, function (mapping) {
            parameters[mapping.targetParameter] = self.piping.parameters.getValue(mapping.sourceParameter);
        });

        return parameters;
    };

    PlugInLogin.prototype.handleResult = function (continuation, result) {
        if (result.status === 'Success') {
            var returnUrl = queryString.getValueOf('ReturnUrl') || lq.getTenantUrl('');

            if (this.eventIsEnabled('userLoggedIn'))
                this.triggerEvent('userLoggedIn', continuation, returnUrl);
            else
                window.location = returnUrl;
        } else {
            if (result.status === 'InvalidCredentials')
                this.handleError('invalidCredentials', 'The credentials are invalid.', continuation);
            else if (result.status === 'InvalidCaptcha')
                this.handleError('invalidCaptcha', 'The captcha is incorrect.', continuation);
            else
                alert('Unable to login.');
        }
    };

    PlugInLogin.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    PlugInLogin.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();
    };

    return PlugInLogin;
});
